import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AdvancedLogoUpload from "@/components/ui/advanced-logo-upload";

interface StandaloneCompanyCreationFormProps {
  companyName: string;
  setCompanyName: (value: string) => void;
  website: string;
  setWebsite: (value: string) => void;
  streetAddress: string;
  setStreetAddress: (value: string) => void;
  suburb: string;
  setSuburb: (value: string) => void;
  city: string;
  setCity: (value: string) => void;
  provinceState: string;
  setProvinceState: (value: string) => void;
  postalCode: string;
  setPostalCode: (value: string) => void;
  setLogoUrl: (url: string | null) => void;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => void;
}

const StandaloneCompanyCreationForm = (props: StandaloneCompanyCreationFormProps) => {
  return (
    <form onSubmit={props.onSubmit} className="space-y-6">
      <div className="space-y-4">
        <div className="text-center">
          <Label className="text-sm font-medium mb-4 block">Company Logo (Optional)</Label>
          <AdvancedLogoUpload onImageUpload={props.setLogoUrl} />
        </div>

        <div className="space-y-2">
          <Label htmlFor="companyName">Company Name *</Label>
          <Input
            id="companyName"
            value={props.companyName}
            onChange={(e) => props.setCompanyName(e.target.value)}
            required
            placeholder="Your company name"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="website">Website (Optional)</Label>
          <Input
            id="website"
            value={props.website}
            onChange={(e) => props.setWebsite(e.target.value)}
            placeholder="www.yourcompany.com or yourcompany.co.za"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="streetAddress">Street Address (Optional)</Label>
          <Input
            id="streetAddress"
            value={props.streetAddress}
            onChange={(e) => props.setStreetAddress(e.target.value)}
            placeholder="123 Main Street"
          />
        </div>

        <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="suburb">Suburb (Optional)</Label>
            <Input
              id="suburb"
              value={props.suburb}
              onChange={(e) => props.setSuburb(e.target.value)}
              placeholder="Suburb"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="city">City (Optional)</Label>
            <Input
              id="city"
              value={props.city}
              onChange={(e) => props.setCity(e.target.value)}
              placeholder="City"
            />
          </div>
        </div>

        <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="provinceState">Province/State (Optional)</Label>
            <Input
              id="provinceState"
              value={props.provinceState}
              onChange={(e) => props.setProvinceState(e.target.value)}
              placeholder="Province or State"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="postalCode">Postal Code (Optional)</Label>
            <Input
              id="postalCode"
              value={props.postalCode}
              onChange={(e) => props.setPostalCode(e.target.value)}
              placeholder="Postal Code"
            />
          </div>
        </div>
      </div>

      <Button type="submit" className="w-full" disabled={props.isLoading}>
        {props.isLoading ? "Creating Company..." : "Create Company"}
      </Button>
    </form>
  );
};

export default StandaloneCompanyCreationForm;